import React, { useState } from "react";
import emailjs from '@emailjs/browser';
import { Icons } from "../components/Icons";
import { CATEGORIES } from "../data/catalog";
import ImageWithFallback from '../components/UI/ImageWithFallback';
const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    company: "",
    phone: "",
    cat: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs.send(
      'service_8ipqpdc', // Replace with your Service ID
      'template_fd4uumj', // Replace with your Template ID
      {
        from_name: form.name,
        reply_to: form.email,
        company: form.company,
        phone: form.phone,
        category: CATEGORIES.find(c => c.id === form.cat)?.name || form.cat,
        message: form.message,
      },
      'Zbr5I4W0i81J2AstA' // Replace with your Public Key
    ).then((result) => {
      setSubmitted(true);
      setForm({
        name: "",
        email: "",
        company: "",
        phone: "",
        cat: "",
        message: "",
      });
      setTimeout(() => setSubmitted(false), 6000);
    }, (error) => {
      alert("Failed to send message: " + error.text);
    });
  };

  return (
    <>
      <div className="page-hero">
        <div className="wrap page-hero-inner">
          <div className="breadcrumb">
            <span>Home</span>
            <Icons.ChevronRight size={12} />
            <em>Contact</em>
          </div>
          <span className="badge badge-blue">Get in Touch</span>
          <h1>Let's Do Business Together</h1>
          <p>
            Ready to place a bulk order or need a custom quote? Fill in the form
            and our wholesale team responds within 24 hours.
          </p>
        </div>
      </div>
      <section className="section">
        <div className="wrap">
          <div className="contact-grid">
            <div className="contact-info-card">
              <div className="contact-img" style={{ position: 'relative', overflow: 'hidden' }}>
                <iframe
                  title="Google Maps Location"
                  width="100%"
                  height="100%"
                  style={{ border: 0, position: 'absolute', top: 0, left: 0 }}
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                  src="https://maps.google.com/maps?q=Academy%20House,%2011%20Dunraven%20Place,%20Bridgend,%20CF31%201JF&t=&z=14&ie=UTF8&iwloc=&output=embed"
                ></iframe>
              </div>
              <div className="contact-info-body">
                <h3>Contact Information</h3>
                {[
                  {
                    icon: <Icons.Mail size={17} />,
                    label: "Email",
                    value: "contact@newcoverltd.co.uk",
                    sub: "We reply within 24 hours",
                  },

                  {
                    icon: <Icons.MapPin size={17} />,
                    label: "Address",
                    value: "Academy House, 11 Dunraven Place",
                    sub: "Bridgend, Mid Glamorgan, UK CF31 1JF",
                  },
                ].map((item, i) => (
                  <div key={i} className="ci-item">
                    <div className="ci-icon">{item.icon}</div>
                    <div>
                      <div className="ci-label">{item.label}</div>
                      <div className="ci-value">{item.value}</div>
                      <div className="ci-sub">{item.sub}</div>
                    </div>
                  </div>
                ))}

              </div>
            </div>

            <div className="contact-form-card">
              <h3 style={{ marginBottom: 6 }}>Send Us a Message</h3>
              <p style={{ marginBottom: 28, fontSize: ".88rem" }}>
                Complete the form below and a wholesale specialist will contact
                you within 24 hours with pricing and availability.
              </p>
              {submitted && (
                <div className="form-success">
                  <Icons.CheckCircle size={17} color="#16a34a" />
                  Message sent! We'll respond within 24 business hours.
                </div>
              )}
              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Full Name *</label>
                    <input
                      className="form-input"
                      type="text"
                      name="name"
                      placeholder="John Smith"
                      value={form.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Email Address *</label>
                    <input
                      className="form-input"
                      type="email"
                      name="email"
                      placeholder="john@company.com"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Company Name</label>
                    <input
                      className="form-input"
                      type="text"
                      name="company"
                      placeholder="Your Company Ltd"
                      value={form.company}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Phone / WhatsApp</label>
                    <input
                      className="form-input"
                      type="tel"
                      name="phone"
                      placeholder="+1 (555) 000-0000"
                      value={form.phone}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Product Category</label>
                  <select
                    className="form-select"
                    name="cat"
                    value={form.cat}
                    onChange={handleChange}
                  >
                    <option value="">Select a category…</option>
                    {CATEGORIES.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.name} {c.sub}
                      </option>
                    ))}
                    <option value="mixed">Multiple / Mixed Categories</option>
                    <option value="custom">Custom Sourcing Request</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">
                    Message / Order Details *
                  </label>
                  <textarea
                    className="form-textarea"
                    name="message"
                    placeholder="Please include: product names, model numbers, quantities needed, destination country, and any specific requirements or timelines…"
                    value={form.message}
                    onChange={handleChange}
                    required
                    rows="5"
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{
                    width: "100%",
                    justifyContent: "center",
                    padding: "14px 24px",
                    fontSize: ".95rem",
                  }}
                >
                  <Icons.ArrowRight size={16} color="#fff" /> Send Message
                </button>
                <p
                  style={{
                    textAlign: "center",
                    fontSize: ".72rem",
                    marginTop: 10,
                    color: "var(--gray-400)",
                  }}
                >
                  Your information is secure and never shared with third
                  parties.
                </p>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
